<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="reports-data">
      <!-- <div class="second-headboard">
      <h1>Reportes</h1>
      <button>Gestión de clientes</button>
      <button>Facturación</button>
      <button>Reporte diario</button>
    </div> -->
    <div><h1>{{ 'reports.title' | translate }}</h1></div>
    <mat-accordion>
      <mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
        <mat-expansion-panel-header>

          <button class="btn-icon btn" title="Buscar" type="button">
            <i class="material-icons">search</i>
          </button>
        </mat-expansion-panel-header>

        <form>
          <fieldset class="fieldset">

            <div fxLayout="row wrap" class="fild_search">
              <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                <div class="pb-16">

                  <mat-form-field class="full-width">
                    <mat-label>{{ 'reports.search.name' | translate }}</mat-label>
                    <input
                       matInput
                       name="name_customer"
                       [disabled]="reportLoading"
                       [(ngModel)]="filter.name_customer">
                    </mat-form-field>
                  </div>
                </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                    <div class="pb-16">
                      <mat-form-field class="full-width">
                        <mat-label>{{ 'reports.search.lastName' | translate }}</mat-label>
                        <input
                           matInput
                           name="lastname_customer"
                           [disabled]="reportLoading"
                           [(ngModel)]="filter.lastname_customer">
                      </mat-form-field>
                    </div>
                  </div>

                <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                  <div class="pb-16">

                    <mat-form-field class="full-width">
                      <mat-label>{{ 'reports.search.dni' | translate }}</mat-label>
                      <input
                        matInput
                         name="identifier_customer"
                         value=""
                         [disabled]="reportLoading"
                         [(ngModel)]="filter.identifier_customer">
                      </mat-form-field>
                    </div>
                  </div>

                  <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                    <div class="pb-16">

                      <mat-form-field class="full-width">
                        <mat-label>{{ 'reports.search.code' | translate }}</mat-label>
                        <input
                          matInput
                         name="code_customer"
                         value=""
                         [disabled]="reportLoading"
                         [(ngModel)]="filter.code_customer">
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                      <div class="pb-16">
                        <mat-form-field class="full-width">
                          <mat-label>{{ 'reports.search.authorizationNumber' | translate }}</mat-label>
                          <input
                           matInput
                           name="authorization_number"
                           [disabled]="reportLoading"
                           [(ngModel)]="filter.authorization_number">
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                      <div class="pb-16">

                        <mat-form-field appearance="fill">
                          <mat-label>{{ 'reports.search.services' | translate }}</mat-label>
                          <mat-select [multiple]="true" [disabled]="reportLoading" [(value)]="selectedServices"
                            (selectionChange)="onServiceSelectionChange($event.value)">
                            <mat-option [value]="'selectAll'">{{ 'reports.search.selectAll' | translate }}</mat-option>
                            @for (service of services; track service) {
                              <mat-option
                                [value]="service.id">{{ service.name_service }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                      </div>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                      <div class="pb-16">

                        <mat-form-field appearance="fill">
                          <mat-label>{{ 'reports.search.plans' | translate }}</mat-label>
                          <mat-select [multiple]="true" [disabled]="reportLoading" [(value)]="selectedPlans"
                            (selectionChange)="onPlanSelectionChange($event.value)">
                            <mat-option [value]="'selectAll'">{{ 'reports.search.selectAll' | translate }}</mat-option>
                            @for (plan of plansByService; track plan) {
                              <mat-option
                                [value]="plan.id">{{ plan.name_plan }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

                      </div>
                    </div>

                    @if (showSubscriptionFilter) {
                      <div fxFlex="100" fxFlex.gt-xs="33" class="pr-16">
                        <div class="pb-16">
                          <mat-form-field appearance="fill">
                            <mat-label>{{ 'reports.search.subscription' | translate }}</mat-label>
                            <mat-select [disabled]="reportLoading" [(value)]="subscriptionStatus"
                              (selectionChange)="onSubscriptionStatusChange($event.value)">
                              <mat-option value="all">{{ 'reports.search.all' | translate }}</mat-option>
                              <mat-option value="active">{{ 'reports.search.active' | translate }}</mat-option>
                              <mat-option value="inactive">{{ 'reports.search.inactive' | translate }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    }


                  </div>

                </fieldset>
                <div class="button_report_align" fxLayout="row" fxLayoutAlign="end center">

                  <button
                    mat-raised-button
                    type="button"
                     color="warn"
                     class="ml-16 mr-16 button_report light"
                     [disabled]="reportLoading"
                     (click)="reset()"
                    >
                    <mat-icon>refresh</mat-icon>
                  </button>

                  <button
                    mat-raised-button
                    type="button"
                    color="primary"
                    class="ml-16 button_report blue"
                    [disabled]="!canListCustomers() || reportLoading"
                    (click)="search()">
                    <mat-icon>search</mat-icon>
                  </button>
                </div>
              </form>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="reports-table-section">
            <div class="reports-table-wrapper">
              <mat-table class="reports-table" [dataSource]="dataSource">


              <ng-container matColumnDef="name_customer">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reports.table.name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="name_customer"> {{ row.name_customer }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="lastname_customer">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reports.table.lastName' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="name_customer"> {{ row.lastName_customer }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="identifier_customer">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reports.table.identifier' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="identifier_customer"> {{ row.identifier_customer }}
                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="code_customer">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reports.table.code' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="code_customer"> {{ row.code_customer }}</mat-cell>
              </ng-container>


              <ng-container matColumnDef="contact">
                <mat-header-cell *matHeaderCellDef> {{ 'reports.table.contact' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="contact">
                  <div class="contact-lines contact-cell">
                    @if (getContactValue(row, 'phone'); as phone) {
                      <div class="contact-line contact-phone">
                        <mat-icon class="contact-icon" aria-hidden="true">phone</mat-icon>
                        <span class="contact-value">{{ phone }}</span>
                      </div>
                    }
                    @if (getContactValue(row, 'email'); as email) {
                      <div class="contact-line contact-email">
                        <mat-icon class="contact-icon" aria-hidden="true">email</mat-icon>
                        <span class="contact-value">{{ email }}</span>
                      </div>
                    }
                    @if (!getContactValue(row, 'phone') && !getContactValue(row, 'email')) {
                      <span class="contact-empty">—</span>
                    }
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="name_plan">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reports.table.plan' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="name_plan"> {{ row.name_plan }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> {{ 'reports.table.actions' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row" data-label="estatus">
                    @if (canSeeCustomerActions()) {
                    <button mat-icon-button [matMenuTriggerFor]="msgMenu" (click)="$event.stopPropagation()"
                       class="hidden-on-open actions-menu-button" [disabled]="reportLoading">
                      <mat-icon class="text-muted">more_vert</mat-icon>
                    </button>
                  }
                  <mat-menu style="width: 200px;" #msgMenu="matMenu">
                    @if (canUpdateCustomer()) {
                      <button mat-menu-item (click)="update(row)" class="menu_report" [disabled]="reportLoading">
                        <mat-icon style="color: white;">refresh</mat-icon>
                        {{ 'reports.actionsMenu.update' | translate }}
                      </button>
                    }
                    @if (canViewCustomerPlans()) {
                      <button mat-menu-item (click)="plans(row)" class="menu_report" [disabled]="reportLoading">
                        <mat-icon style="color: white;">assignment</mat-icon>
                        {{ 'reports.actionsMenu.plans' | translate }}
                      </button>
                    }
                    @if (canManageCustomerCards()) {
                      <button mat-menu-item (click)="creditcard(row)" class="menu_report" [disabled]="reportLoading">
                        <mat-icon style="color: white;">credit_card</mat-icon>
                        {{ 'reports.actionsMenu.cards' | translate }}
                      </button>
                    }
                    @if (canViewCustomerSubscriptions()) {
                      <button mat-menu-item (click)="invoices(row)" class="menu_report" [disabled]="reportLoading">
                        <mat-icon style="color: white;">receipt</mat-icon>
                        {{ 'reports.actionsMenu.invoices' | translate }}
                      </button>
                    }
                    @if (row.canBeDeleted) {
                      <button mat-menu-item (click)="delete(row)" class="menu_report" [disabled]="reportLoading">
                        <mat-icon style="color: white;">delete</mat-icon>
                        {{ 'reports.actionsMenu.delete' | translate }}
                      </button>
                    }
                  </mat-menu>
                </mat-cell>
              </ng-container>


              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;">
              </mat-row>
              </mat-table>
            </div>
            <mat-paginator showFirstLastButtons
              [length]="tableService.pager.totalEntities"
               [pageIndex]="tableService.pager.pageIndex"
               [pageSize]="tableService.pager.pageSize"
               [pageSizeOptions]="[20, 50, 100]"
               [disabled]="reportLoading"
               (page)="list($event)">
            </mat-paginator>
          </div>

        </div>
        <div class="options-buttons">
          <button class="back-btn" (click)="goBack()">{{ 'reports.back' | translate }}</button>
        </div>
      </div>
    </body>
